"use client";

import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <div className="flex w-full flex-col gap-2">
        {label && (
          <label className="text-sm font-semibold leading-5 text-[#1c2024]">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={cn(
            "flex min-h-[64px] w-full rounded border border-[rgba(0,9,50,0.12)] bg-[rgba(255,255,255,0.9)] p-2 text-sm leading-5 text-[#1c2024] placeholder:text-[rgba(0,5,29,0.45)] focus:border-[rgba(0,9,50,0.2)] focus:outline-none focus:ring-2 focus:ring-[rgba(0,78,154,0.1)] disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          {...props}
        />
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };

